import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    homeData: {completeOrderCount:0,customer:0,newOrder:0,orderCount:0,newOrderCount:0,userLevel:{levelHigher:300,levelHigherSpot:300,levelId:0},userNme:{loanRuleIsRead:1},userSaleAuthentication: null},
    partnerHomeData: {},
    commissionData: {commissionPrice: '0',instalmentTotal: 0,orderPrice:'0',rewardOrderCount:250,userCount:0,userSaleAuthentication:null},
    accountData: {list:[], pagenation: {total: 0,page: 0}},
    flag: '1',
    questionstatus: false,
    sales: {
      name: '',
      tel: '',
      store: '',
      imgList:[],
    },
    planObj: {}
  },
  
  mutations: {
    // 首页数据
    setHomeData(state, homeData) {
      state.homeData = homeData;
    },
    // 全民伙伴首页数据
    setPartnerHomeData(state, partnerHomeData) {
      state.partnerHomeData = partnerHomeData
    },
    // 可提现佣金页数据
    setCommissionData(state, commissionData) {
      state.commissionData = commissionData
    },
    // 订单管理和最新状态页
    setAccountData(state, accountData) {
      state.accountData = accountData
    },
    setFlag(state,flag) {
      state.flag = flag
    },
    setquestionstatus(state, status) {
      state.questionstatus = status
    },
    setSales(state, sales) {
      state.sales = sales
    },
    // setImgList(state, imgList) {
    //   state.imgList = imgList
    // }
  },
  getters: {
    changePlan(obj) {
      state.planObj = obj
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js